import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
function useDevice() {
	return useContext(AppContext);
}

export default useDevice;
